module.exports = __webpack_public_path__ + "static/line-detail-colors-compressed.94e37aca.jpg";